import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        minWidth: '300px',
        '& > main': {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
        },
    },
    rootNoPadding: {
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        minWidth: '300px',
        overflow: 'hidden',
        '& > main': {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
        },
    },
}));
